<div class="return-forms-error">
    <ws-modal-wrapper [headerLabel]="modalTitle"
                      [hideCancel]="!showCancel"
                      (save)="accept()"
                      (cancel)="cancel()">
        <div class="ws-flex-container-vertical ws-stretch">
            @for (errorType of errorTypes; track errorType) {
                <div class="split">
                    <span class="error-description">{{ aggregate[errorType].label }}:</span>
                    <div class="error-container">
                        <div>
                            @for (error of aggregate[errorType].errors; track error) {
                                <div (click)="toggleParcels(error)">
                                    <div class="form-error">
                                        <i class="fa fa-caret-right show-details" [class.open]="error.showForms"></i>
                                        <span class="form-name">{{ error.assessor }}</span>
                                        <span>{{ error.descriptor }}</span>
                                    </div>
                                    <ul class="closed" [class.open]="error.showForms">
                                        @for (parcel of error.forms; track parcel) {
                                            <li>{{ parcel }}</li>
                                        }
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                    <span class="error-description">{{ aggregate[errorType].warning }}</span>
                </div>
            }
        </div>
    </ws-modal-wrapper>
</div>
